import {css} from '../../utils.js';

const styles = css`
    .VirtualSelectGrid {
        z-index: 1;
    }
    .VirtualizedSelectOption {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        padding: 0px 0.5rem;
    }
    .VirtualizedSelectFocusedOption {
        background-color: rgba(0, 126, 255, 0.1);
    }
    .VirtualizedSelectDisabledOption {
        opacity: 0.5;
    }
    .VirtualizedSelectSelectedOption {
        font-weight: bold;
    }
`;

export default styles;
